// extracted by mini-css-extract-plugin
export var articleContainer = "Article-module--articleContainer--Y2u7X";
export var articleImage = "Article-module--articleImage--10BqJ";
export var breadcrumb = "Article-module--breadcrumb--sOiSE";
export var canopyGreen = "Article-module--canopyGreen--6UAd0";
export var carbonGrey = "Article-module--carbonGrey--L5W2M";
export var copyContainer = "Article-module--copyContainer--NWB9a";
export var dawnPink = "Article-module--dawnPink--6VANL";
export var fadeInOut = "Article-module--fadeInOut--v00KL";
export var headlineContainer = "Article-module--headlineContainer--7PWM0";
export var hide = "Article-module--hide--4iIbv";
export var hiveYellow = "Article-module--hiveYellow--ztwGz";
export var horizonWhite = "Article-module--horizonWhite--Qvmct";
export var imgLink = "Article-module--imgLink--DIquM";
export var multiComponentImage = "Article-module--multiComponentImage--ldWDA";
export var oceanicBlue = "Article-module--oceanicBlue--MBFTi";
export var page404Title = "Article-module--page404-title--z2dmj";
export var playerWrapper = "Article-module--playerWrapper--vE1CU";
export var show = "Article-module--show--V3uz+";
export var simpleColouredCopyBlock = "Article-module--simpleColouredCopyBlock--uFtwJ";
export var simpleRichTextArea = "Article-module--simpleRichTextArea--lAa1D";
export var socialIconsContainer = "Article-module--socialIconsContainer--hdvha";
export var stickyHeadlineContainer = "Article-module--stickyHeadlineContainer--+KDPC";
export var stickySocialIconsContainer = "Article-module--stickySocialIconsContainer--2MCQM";
export var tagsContainer = "Article-module--tagsContainer--9KnO+";
export var videoButton = "Article-module--videoButton--DIhCR";
export var videoLaunch = "Article-module--videoLaunch--rY0Kb";
export var videoPictureWrap = "Article-module--videoPictureWrap--5tMAf";
export var videoPlayer = "Article-module--videoPlayer--NZUd0";
export var videoWrap = "Article-module--videoWrap--nNjdx";